import React, { CSSProperties } from 'react'

import { Button, Placeholder, Typography } from '../..'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'

import styles from './styles.module.css'

interface FeaturedImageProps {
  /**
   * The title of the image
   */
  title: string
  /**
   * The subtitle of the image
   */
  subtitle: string
  /**
   * The url of the image
   */
  imageUrl: string
  /**
   * Show or hide the button
   * @default false
   */
  showButton?: boolean
}

function FeaturedImage(props: Readonly<FeaturedImageProps>) {
  const { title, subtitle, imageUrl, showButton = true } = props

  return (
    <div
      className={styles.featuredImage}
      style={
        {
          '--imageUrl': `url(${imageUrl})`,
        } as CSSProperties
      }
      data-testid="destination-card"
    >
      <div className={styles.featuredImageContent}>
        <header>
          <Typography as="h5" variant="title" size="s" clamp={3}>
            {title}
          </Typography>
          <Typography variant="caption" size="l" clamp={3} bold>
            {subtitle}
          </Typography>
        </header>
        <footer>
          {showButton && (
            <Button variant="icon-rounded" size="small" leadingIcon={<IconArrowRight />} />
          )}
        </footer>
      </div>
    </div>
  )
}

function FeaturedImagePlaceholder() {
  return <Placeholder height="350px" width="260px" rounded />
}

FeaturedImage.Placeholder = FeaturedImagePlaceholder

export default FeaturedImage
